
import React,{Fragment, useEffect,useRef,useState} from 'react'
import {getContentPath} from  'system/AssetManager'
import ControllerPDFUI from './ControllerPDFUI';
import {fetchCMSJSON,fetchCMSJSONs} from 'system/AssetManager'
import gsap,{Power2} from 'gsap'
import { pdfjs, Document, Page } from 'react-pdf';
import Globals  from 'system/Globals';
import styles from './controller-narrative.module.css'
import nstyles from '../narrative/narrative.module.scss'
import mstyles from '../narrative/modules/modules.module.css'
import NarrativeMenuItem  from 'narrative/NarrativeMenuItem'
import ControllerServerComs from 'system/ControllerServerComs'
import {ReactComponent as Chevron} from '../assets/icons/caret_down.svg'
import {ReactComponent as CloseButton} from '../assets/icons/close.svg'
import {ReactComponent as Apps} from 'assets/icons/apps.svg'
import {ReactComponent as CaretRight} from '../assets/icons/caret_right.svg'
import {ReactComponent as CaretLeft} from '../assets/icons/caret_left.svg'


const ControllerPDF = (props)=>{

    const pdfControls = useRef();
    const scrollContainer = useRef();
    const [format,setFormat] = useState(null)
    const [backgroundColor, setBackgroundColor] = useState('#6a6a6a');
    const [menuOpen, setMenuOpen] = useState(true);
    const [selected,setSelected] = useState(null)
    const [selectedId, setSelectedId] = useState(null);
    const [styleMenu,setStyleMenu]=useState({})
    const [menuItems,setMenuItems] = useState([])
    const [styleMenuSelected,setStyleMenuSelected]=useState({})
    const [pdfItems, setPDFItems] = useState(null);
    const [activePage, setActivePage] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pages, setPages] = useState(0);
    const [pdfPath, setPdfPath] = useState();
    const [prevImage, setPrevImage] = useState(null);
    const [nextImage, setNextImage] = useState(null);
    const [pdfDoc, setPdfDoc] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [thumbnailsLoading, setThumbnailsLoading] = useState(false);

    function processParams(){
        let params = new URLSearchParams(props.params);
        let file0 = params.get('file');

        if (file0){
            let fileId = parseInt(file0);
            let fileIndex = pdfItems.map(function(x) {return x.id; }).indexOf(fileId);
            let catId;
            onThumbnailClick(pdfItems[fileIndex].id, pdfItems[fileIndex].fileType, "", "params", catId)
            
            let dest = document.getElementById('galleryThumb_' + fileId);
            dest.scrollIntoView()
        }   
        
        
        props.setCurrentParams(null);

    }
    
    useEffect(()=>{

        console.log('pdf props', props)

        if (Globals.instance().electron || Globals.instance().ipad) {
            if (Globals.instance().ipad) {
                pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';
            } else {
                pdfjs.GlobalWorkerOptions.workerSrc = Globals.instance().appPath + '/pdf.worker.js';
            }
        } else {
            pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
        }

        if (props.model.backgroundColor) {
            setBackgroundColor(props.model.backgroundColor);
        }

        if (props.model.formats) {

            setFormat( Globals.instance().getFormat(props.model.formats))
            console.log('setting gallery format', Globals.instance().getFormat(props.model.formats), props.model.formats)

        }

        return () => {
            setSelectedId(null);
            // setSelected(0);
        }
    },[])

    useEffect(() => {
        if (props.reload > -1) {
            console.log('reload', props.reload)

            setSelected(null);
        }
        
    }, [props.reload])

    useEffect(() => {
        if (props.params && menuItems && (menuItems.length > 0)) {
            processParams();
        }
    }, [props.params, menuItems])

    useEffect(() => {
        console.log('selectedId', selectedId)
        if (selectedId !== null) {
            props.setPopup(true);
            gsap.to(pdfControls.current, {opacity: 1, zIndex: 10, duration: 0.3})
        }
        else {
            props.setPopup(false);
            gsap.to(pdfControls.current, {opacity: 0,zIndex: -1, duration: 0.3});
            ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-command',"close");
            setPrevImage(null);
            setNextImage(null);
            setPdfDoc(null);
            setTotalPages(0);
        }

    }, [selectedId])

    useEffect(()=>{
        if (props.module.docs) {
            // setSelected(0);
            // setActivePage(props.activeNarrativePageIndex);
            // props.setActiveNarrativePageIndex(null);
   

            let arr = []
            if(props.module.docs)
                arr=arr.concat(props.module.docs)
            if(props.module.screenshot && props.module.screenshot.document)
                arr.push(props.module.screenshot)
            
            setPDFItems(arr);

            let arrMenuItems=[]
            arr.forEach((obj,i)=>{
                arrMenuItems.push({label:obj.caption, 'id': i, 'index': i})
            })
            setMenuItems(arrMenuItems)
          
            console.log('controller documents', props.module.docs)
            setStyleMenu(Globals.instance().getThemeStyle(['nav-menu-item'],props.theme))
            setStyleMenuSelected(Object.assign({},Globals.instance().getThemeStyle(['nav-menu-item'],props.theme),{color:'var(--primary-accent)', '--hover-color': 'var(--primary-accent)'}))
            // setCategories(props.module.mapboxes)
        } 
          // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [props.module.docs])




    function handleMenu(){
        if (menuOpen) {
            setMenuOpen(false)
        } else {
            setMenuOpen(true);
        }
    }

    async function renderPageToDataURL(pdf, pageNum, scale = 0.3) {
        if (pageNum < 1 || pageNum > pdf.numPages) return null;
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');
        await page.render({ canvasContext: ctx, viewport }).promise;
        return canvas.toDataURL('image/jpeg', 0.7);
    }

    async function updateThumbnails(pdf, currentPage) {
        setThumbnailsLoading(true);
        setPrevImage(null);
        setNextImage(null);
        const prev = await renderPageToDataURL(pdf, currentPage - 1);
        const next = await renderPageToDataURL(pdf, currentPage + 1);
        setPrevImage(prev);
        setNextImage(next);
        setThumbnailsLoading(false);
    }

    async function onThumbnailClick(path, i) {
        console.log("onThumbnailClick", path, i);
        props.setShowModules(false);
        setSelectedId(i);
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-select-file', path);
        setPageNumber(1);
        setThumbnailsLoading(true);
        setPrevImage(null);
        setNextImage(null);

        try {
            const loadingTask = pdfjs.getDocument(getContentPath(path));
            const pdf = await loadingTask.promise;
            setPdfDoc(pdf);
            setTotalPages(pdf.numPages);
            await updateThumbnails(pdf, 1);
        } catch (err) {
            console.error('Failed to load PDF for thumbnails', err);
            setThumbnailsLoading(false);
        }
    }
     const onClickLink = (index) => {
        // props.setShowModules(false);
         console.log('onClickLink',index)
         let d = pdfItems[Number(index)]
        console.log('onClickLink doc', d, index, pdfItems)
        // let f = d.file
        // if(!f )return
        // if(f.indexOf("http")===-1){
        //     f=Globals.instance().webURL+'/media/'+f;
        // }

        // ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-select-file', d.id);
        onThumbnailClick(d.document, index);

    }   

    const onClickClose = () => {
        console.log('close')

        
       
    }

   

    const onZoomOut = () => {
        // console.log('zoomOut') 
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-command', "vrzoomout");
     }
 
     const onZoomIn = () => {
        //  console.log('zoomIn') 
         ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-command', "vrzoomin");
      }

      const onPrevClick = async () => {
        console.log('onPrevClick')
        let newPageNumber = pageNumber-1;
        console.log('onClickLeft', newPageNumber)
        if ((newPageNumber) >= 1) {
            setPageNumber(newPageNumber)
            ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-command','prev');
            if (pdfDoc) await updateThumbnails(pdfDoc, newPageNumber);
        }

     }

     const onNextClick = async () => {

        console.log('onNextClick')
        let newPageNumber = pageNumber+1;
        console.log('onClickRight', newPageNumber)
        if (pdfDoc && (newPageNumber) <= totalPages) {
            setPageNumber(newPageNumber)
            ControllerServerComs.instance().sendUDPFromControllerToServer('module-pdf-command',"next");
            await updateThumbnails(pdfDoc, newPageNumber);
        }

     }

     const onKeyToggle = (command) => {
        console.log('onArrow', command) 
        ControllerServerComs.instance().sendUDPFromControllerToServer('key', command);
     }

     const onClickBack = () => {
        console.log('onClickBack', props.activePage) 
        props.setCurrentModule({typeName: 'controller-narrative'});
        // props.setActiveNarrativePageIndex(activePage);
        props.setAnimInCurrentModule(false);
        ControllerServerComs.instance().sendUDPFromControllerToServer('narrative-close-module');

        console.log('props', props)
        // setSelected(null);
        // setShowLanding(true);
     }

    return (
        <React.Fragment>
            <div className={`${styles.linksContainer} ${styles.moduleLinksContainer} hide-scroller ${nstyles.galleryLinksContainer}`}>

            {!props.showModules && <span className={styles.switchMenu} onClick={() => props.setShowModules(showModules => !showModules)}><span className={nstyles.switchMenuBtn}><Apps /></span><h4>{props.module.title}</h4></span>}
            

            <div className={`${styles.controllerLinks} hide-scroller`} >

                    {!props.showModules && menuItems && (menuItems.length > 0) && menuItems.map((val, index) => (
                 
               
                            <span 
                                key={`pdf_menu_${index}`}
                                className={styles.controllerMenuLinkRow}
                                onClick={() => onClickLink(index)}
                            >
                                <NarrativeMenuItem
                                model={val}
                                objId={val.id}
                                index={index}
                                onClickLink={() => {}}
                                onExpand={()=>{}}
                                className={nstyles.menuLink+' '+styles.controllerMenuLink+' '}
                                theme={props.theme}
                                activePage={activePage && activePage}
                                style={selected===index ? styleMenuSelected : styleMenu}
                                ></NarrativeMenuItem>

                            </span>
         
               
                    ))}
                    </div>
            
            </div>

            {
            <section ref={scrollContainer} className={`${styles.moduleHolder}`}>
                {props.showBackBtn && (selectedId === null) && <div className={`${styles.backBtnRow}`}>
                    <div className={`${styles.pillBtn}`} onClick={() => onClickBack()}>Back to Presentation</div>
                </div>}


                <div className={`${styles.galleryThumbnails} ${(props.showBackBtn)?styles.hasBackBtnRow:""}`}>
                    {pdfItems && pdfItems
                        .sort((a, b) => a.ordering - b.ordering)
                        .map((file, i) => (
                        <div 
                            onClick={() => onThumbnailClick(file.document, i)}
                            key={'gallery_file_' + i}
                            id={"galleryThumb_" + i}
                            className={`${styles.galleryThumbnail} ${(selectedId === i)?"linkOn":""}`}
                        >
                        <img src={getContentPath(file.image)} alt="" />
                        {(file.caption) ? 
                            <div 
                            className={`${styles.caption}`}
                       
                            >{file.caption}</div> 
                            : null}
                        </div>
                    ))}</div>
                
                    <div className={`${styles.moduleThumbsScrollContainerGradient}`}></div>
                  
            </section>}

            <React.Fragment>
                <ControllerPDFUI ref={pdfControls} prevImage={prevImage} nextImage={nextImage} thumbnailsLoading={thumbnailsLoading} pageNumber={pageNumber} totalPages={totalPages} onPrevClick={onPrevClick} onNextClick={onNextClick} ></ControllerPDFUI>

                {console.log('pdfItems', pdfItems)}
                
                {selectedId !== null && <span className={`${styles.joystickClose}`}>
                    <div className={`${mstyles.closeBtnContainer}`}>
                        <div className={`round-btn`} onClick={() => setSelectedId(null)} style={Globals.instance().getThemeStyle(['nav-menu-btn'],props.theme)}>
                        <CloseButton></CloseButton>
                        </div>
                    </div>
                </span>}
                </React.Fragment>

        </React.Fragment>
    )

}

export default ControllerPDF
